export default __webpack_public_path__ + "static/media/Preisliste2021.a3773de4.pdf";